import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  // Show loading spinner while Clerk initializes
  if (!isLoaded) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-b from-background to-muted/30">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // Check for mentee device-only mode (allows access without Clerk auth)
  const isDeviceOnlyMode = localStorage.getItem('mentee_device_mode') === 'true';
  const hasDeviceSerial = localStorage.getItem('device_serial');

  // Allow access if signed in OR if mentee device mode is active with a serial
  if (!isSignedIn && !(isDeviceOnlyMode && hasDeviceSerial)) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // User is signed in, render the protected content
  return <>{children}</>;
};
